import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid,Select,MenuItem,FormControl,InputLabel } from '@mui/material';
import { CustomTextField, CustomDateField } from './CustomTextField';
const CompanyForm = ({ open, handleClose, data, handleSave, handleDelete,filterCartDataByDiviNum,familyData }) => {
 const [formData, setFormData] = useState(data || {});


 const jinState = filterCartDataByDiviNum(13); // 회사종류


  useEffect(() => {
    if (!data) {
      // 새로 추가할 때 기본적으로 본인을 선택
      const primaryMember = familyData.find(member => member.cDaeCode === member.cCode);
      setFormData(primaryMember => ({
        ...primaryMember,
        cCode: primaryMember.cDaeCode,
      }));
    } else {
      // 수정 시 기존 데이터를 그대로 사용
      setFormData(data);
    }
  }, [data, familyData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const saveChanges = () => {
    handleSave(formData);
  };

  const deleteChanges = () => {
    handleDelete(formData);
  };

  const isUpdate = !!formData.gNum;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isUpdate ? '사업자 수정' : '사업자 추가'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Select
                name="cCode"
                value={formData.cCode || ''}
                onChange={handleChange}
                fullWidth
              >
                {familyData.map((member) => (
                  <MenuItem key={member.cCode} value={member.cCode}>
                    {member.cName}
                  </MenuItem>
                ))}
              </Select>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="dense">
              <InputLabel>종류</InputLabel>
              <Select
               label="종류"
                name="companyDivi"
                value={formData.companyDivi || ''}
                onChange={handleChange}
                fullWidth
              >
                {
                  jinState.map((code) => (
                    <MenuItem key={code.cartName} value={code.cartName}>
                      {code.cartName}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>

           
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="dense"
              name="companyName"
              label="기업명"
              type="text"
              fullWidth
              value={formData.companyName || ''}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="dense"
              name="daeName"
              label="대표자명"
              type="text"
              fullWidth
              value={formData.daeName || ''}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="dense"
              name="saNumber"
              label="사업자번호"
              type="text"
              fullWidth
              value={formData.saNumber || ''}
              onChange={handleChange}
            />
          </Grid>
          
          <Grid item xs={12} sm={6}>
            <TextField
              margin="dense"
              name="giSawonName"
              label="기장담당자"
              type="text"
              fullWidth
              value={formData.giSawonName || ''}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="dense"
              name="giStartDate"
              label="기장시작일"
              type="text"
              fullWidth
              value={formData.giStartDate || ''}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="dense"
              name="giEndDate"
              label="기장종료일"
              type="text"
              fullWidth
              value={formData.giEndDate || ''}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              margin="dense"
              name="giMoney"
              label="기장료"
              type="number"
              fullWidth
              value={formData.giMoney || ''}
              onChange={handleChange}
            />
          </Grid>
         
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          취소
        </Button>
        {isUpdate && (
          <Button onClick={deleteChanges} color="primary">
            삭제
          </Button>
        )}
        <Button onClick={saveChanges} color="primary">
          저장
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompanyForm;
